import slack from './slack.svg';
import telegram from './telegram.svg';
import skype from './skype.svg';

export default {
  slack,
  telegram,
  skype,
} as const;
